import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import PropTypes from 'prop-types';
import FindModuleById from '.././FindModuleById';

import { base_url, Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';
const InvoicingHeaders = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
  let season_id = localStorage.getItem("season_id");
  let para ={season_id:season_id};
  useEffect(() => {
    setPermission(FindModuleById(181)); 
    console.log(permission);
    axios
      .post(
        "/invoices/listing",
       para, 
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.invoices);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
 
  const deleteItem = (item) => {
      let season_id = localStorage.getItem("season_id");

    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/invoices/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                  axios.post("/invoices/listing",
                    para,  { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }}
                    ).then((response) => {
                      if (response.data.code === 200) {
                        setData(response.data.data.invoices);
                      }
                    }).catch((error) => {
                      console.log(error);
                    });
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }
  const viewItem = (item)=>{
    window.location.href = "/invoices-view/"+item;

  }
  const viewPayment = (item)=>{
    window.location.href = "/invoices-payment/"+item;

  }
  const editItem = (item)=>{
    if(item.type == 2){
      window.location.href = "/invoices-edit/"+item.id;
    }else{
      alert('This is  Packing List invoice which can not update');
    }

    
  }
  
// ✅ Invoice Link Cell Component
const InvoiceLinkCell = ({ row }) => {
  const url = `/invoices-view/${row.original.id}`;
  return <a href={url}>{row.original.invoice_number}</a>;
};

// ✅ PropTypes Validation
InvoiceLinkCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.any.isRequired,
      invoice_number: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Columns Definition
const columns = [
  {
    header: 'Invoice Number',
    accessorFn: (row) => row.invoice_number,
    Cell: InvoiceLinkCell,
  },
  {
    header: 'PO Order Number',
    accessorKey: 'po_order_number',
  },
  {
    header: 'Date',
    accessorKey: 'date',
  },
  // {
  //   header: 'Customer',
  //   accessorFn: (row) => row.customer_detail?.company_name || '',
  // },
    {
      header: 'Customer',

      accessorFn: (row) => {
        if (row.customer_type == 'invoice') {
          return row.customer_detail?.company_name || '';
        }
        else if (row.customer_type == null) {
          return row.customer_detail?.company_name || '';
        }
        else{
          return row.supplier_details?.name || '';
        }
      
      },
    },
  {
    header: 'Invoice Type',
    accessorFn: (row) => row.invoicetype?.title || 'Invoice generated from Packing List',
  },
  {
    header: 'Total Amount',
    accessorFn: (row) => `${row.net_amount}${row.customer_currency?.symbol || ''}`,
  },
  // {
  //   header: 'Invoicing Address',
  //   accessorFn: (row) => row.invoice_add?.name || '',
  // },
    {
      header: 'Invoicing Address',

      accessorFn: (row) => {
        if (row.customer_type == 'invoice') {
          return row.invoice_add?.name || '';
        }
        else if (row.customer_type == null) {
          return row.invoice_add?.name || '';
        }
        else{
          return row.invoicing_address || '';
        }
      
      },
    },
  // {
  //   header: 'Shipping Address',
  //   accessorFn: (row) => row.shipping_add?.name || '',
  // },
  
    {
      header: 'Shipping Address',

      accessorFn: (row) => {
        if (row.customer_type == 'invoice') {
          return row.shipping_add?.name || '';
        }
        else if (row.customer_type == null) {
          return row.shipping_add?.name || '';
        }
        else{
          return row.invoicing_address || '';
        }
      
      },
    },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
  },
];
    
const downloadInvoices = async () => {
    let season_id = localStorage.getItem("season_id");

     window.open(`${base_url}/invoices/download-invoices?season_id=${season_id}`, '_blank');
};

return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Invoices</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Invoice</li>
                  </ul>
                </div>
                <div className="col-auto">
                  {permission?.add == 1 && (
                    <Link to="/invoices-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                    )} 
                   <button   onClick={() => downloadInvoices()}   className="btn btn-primary me-1"  > Download  <i className="fa fa-pdf" />  </button>
                                     
                 
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                  <div className="card-body">
                    <div className="table-responsive">
                    {permission?.list == 1 && (
                      <MaterialReactTable columns={columns} data={data} 
                      enableColumnOrdering
                      enablePinning
                      enableRowActions
                      //renderColumnActionsMenuItems 
                        renderRowActionMenuItems={({ row }) => [
                      permission?.update === 1 && row.original.type ==2  && (
                        <MenuItem key="edit" onClick={() => editItem(row.original)}>
                          Edit
                        </MenuItem>
                      ),
                      permission?.delete == 1 && (
                        <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                          View
                        </MenuItem>
                      ),
                      permission?.add == 1 &&   row.original.invoice_type !=2 &&  (
                        <MenuItem key="payment" onClick={() => viewPayment(row.original.id)}>
                          Payment
                        </MenuItem>
                      ),
                      permission?.delete == 1 && (
                        <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                          Delete
                        </MenuItem>
                      ),
                    ]}

                    
                    />
                    )}
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default InvoicingHeaders;
